import { render, staticRenderFns } from "./CustomerAuth.vue?vue&type=template&id=bcfc4806&scoped=true&"
import script from "./CustomerAuth.vue?vue&type=script&lang=js&"
export * from "./CustomerAuth.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAuth.vue?vue&type=style&index=0&id=bcfc4806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfc4806",
  null
  
)

export default component.exports